import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Flex, Box } from 'reflexbox';
import {
  Message,
  Text,
} from 'rebass';
import { Link } from 'react-router';
import axios from 'axios';

// ignore because the banner is constantly being shown/hidden and i don't want to un/comment this every time
// eslint-disable-next-line
import config from 'frontend/config';
import {
  If,
  SmallButton,
  Loader,
} from 'frontend/components';
import { DAYS } from 'shared/util';
import SharedConfig from 'shared/config';

import { selectors as versionSelectors } from 'frontend/state/reducers/version';
import { selectors as userSelectors } from 'frontend/state/reducers/user';
import { selectors as siteSelectors } from 'frontend/state/reducers/site';

import BannerAlertText from './BannerAlertText';

class Banner extends React.Component {
  static propTypes = {
    patron: PropTypes.bool,
    newVersionAvailable: PropTypes.bool,
    email: PropTypes.string,
    emailVerified: PropTypes.bool,
    emailVerifyLastRequest: PropTypes.string,
    isBetaSite: PropTypes.bool,
    alertMessage: PropTypes.string,
    alertLinkText: PropTypes.string,
    alertLinkUrl: PropTypes.string,
    alertTheme: PropTypes.string,
  };

  static defaultProps = {
    patron: false,
    newVersionAvailable: false,
    emailVerified: true,
    emailVerifyLastRequest: null,
    email: null,
    isBetaSite: false,
    alertMessage: null,
    alertLinkText: null,
    alertLinkUrl: null,
    alertTheme: null,
  };

  state = {
    confirmLoading: false,
    confirmSuccess: false,
    confirmHide: false,
  };

  requestConfirmEmail = async () => {
    this.setState({
      confirmLoading: true,
      confirmSuccess: false,
      confirmError: null,
    });

    try {
      await axios.post('/api/account/request-verify');

      this.setState({
        confirmLoading: false,
        confirmSuccess: true,
      });
    } catch (error) {
      this.setState({
        confirmLoading: false,
        confirmSuccess: false,
        confirmError: error.response.data.message || 'Seri forgot to handle an error!',
      });
    }
    setTimeout(() => {
      this.setState({ confirmHide: true });
    }, 15 * 1000);
  };

  render() {
    const {
      newVersionAvailable,
      patron,
      emailVerified,
      email,
      emailVerifyLastRequest,
      isBetaSite,
      alertMessage,
      alertLinkText,
      alertLinkUrl,
      alertTheme,
    } = this.props;

    // eslint-disable-next-line prefer-const
    let message = null;
    let premiumMessage = null;
    let theme = 'success';
    if (newVersionAvailable) {
      theme = 'warning';
      // message = 'Raidbots has been updated, reload to get the latest and greatest!';
    } else if (!patron) {
      premiumMessage = (
        <span>
          <Link
            to="/account"
            href="/account"
          >
            Sign up for Raidbots Premium!
          </Link>
          {' '}{' '}
          Skip the line, run larger sims, and more!
        </span>
      );
    }

    if (isBetaSite) {
      theme = 'error';
      message = (
        'PTR/beta sims tend to be unstable and/or incomplete! There are no guarantees PTR/beta changes are in place!'
      );
    } else if (alertMessage || alertLinkText) {
      theme = alertTheme || 'success';
      message = (
        <BannerAlertText
          message={alertMessage}
          linkText={alertLinkText}
          linkUrl={alertLinkUrl}
        />
      );
    }

    const timeSinceLastVerify = new Date().getTime() - new Date(emailVerifyLastRequest).getTime();
    const nagThreshold = SharedConfig.account.emailVerifyNagDays * DAYS;
    const showEmailVerification = email && !emailVerified && timeSinceLastVerify > nagThreshold;

    return (
      <>
        <If
          condition={message}
          then={() => (
            <Message theme={theme} style={{ display: '', textAlign: 'center' }} p={1} mt={1}>
              {message}
            </Message>
          )}
        />
        <If
          condition={!showEmailVerification}
          then={() => (
            <If
              condition={premiumMessage}
              then={() => (
                <Message theme="primary" style={{ display: '', textAlign: 'center' }} p={1} mt={1}>
                  {premiumMessage}
                </Message>
              )}
            />
          )}
        />
        <If
          condition={showEmailVerification && !this.state.confirmHide}
          then={() => (
            <Message theme="secondary" style={{ display: '', textAlign: 'center' }} p={1} mt={1}>
              <If
                condition={this.state.confirmError}
                then={() => (
                  <Text>{this.state.confirmError}</Text>
                )}
                else={() => (
                  <If
                    condition={this.state.confirmSuccess}
                    then={() => (
                      <Text>Email sent! Check your inbox for the confirmation link</Text>
                    )}
                    else={() => (
                      <Flex justify="center" align="center">
                        <Flex column>
                          <Box>
                            Please confirm your email address
                          </Box>
                          <Text small>
                            You can change your email on your
                            {' '}
                            <Link to="/account" style={{ color: config.colors.black, textDecoration: 'underline' }}>
                              account page
                            </Link>
                            .
                            {' '}
                            Not receiving the email?
                            {' '}
                            <a
                              href="https://support.raidbots.com/article/7-im-not-receiving-emails"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: config.colors.black, textDecoration: 'underline' }}
                            >
                              Check here
                            </a>
                          </Text>
                        </Flex>

                        <Box ml={2}>
                          <Loader
                            loading={this.state.confirmLoading}
                            loaded={() => (
                              <SmallButton theme="success" onClick={this.requestConfirmEmail}>
                                Send confirmation link
                              </SmallButton>
                            )}
                          />
                        </Box>
                      </Flex>
                    )}
                  />
                )}
              />
            </Message>
          )}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  patron: userSelectors.isPatron(state),
  newVersionAvailable: versionSelectors.newVersionAvailable(state),
  emailVerified: userSelectors.emailVerified(state),
  emailVerifyLastRequest: userSelectors.emailVerifyLastRequest(state),
  email: userSelectors.email(state),
  isBetaSite: siteSelectors.isBetaSite(state),
  alertMessage: siteSelectors.alertMessage(state),
  alertLinkText: siteSelectors.alertLinkText(state),
  alertLinkUrl: siteSelectors.alertLinkUrl(state),
  alertTheme: siteSelectors.alertTheme(state),
});

export default connect(mapStateToProps)(Banner);
